<script setup lang="ts">
import type { IconName } from '@ui/components/icon/types'
import Icon from '@ui/components/icon/Icon.vue'

withDefaults(
  defineProps<{
    active?: boolean
    icon?: IconName
    disabled?: boolean
  }>(),
  {
    active: false,
    icon: '',
  },
)
</script>

<template lang="pug">
button.control-button.flex-center-center.typ-16-24-500.br-10.cursor-pointer(type="button" :disabled="disabled" :aria-disabled="disabled || undefined" :class="[active && 'active', icon ? 's-32 p-6' : 'h-32 p-4-12']")
  Icon.s-20(v-if="icon" :name="icon")
  template(v-else)
    slot
</template>

<style scoped>
.control-button {
  background: var(--cue-bg-neutral-none);
  border: none;
  outline: none;
  color: var(--cue-content-neutral-secondary);
  transition: 0.3s ease;
  transition-property: background, color;

  &:not(:disabled):hover {
    background: var(--cue-bg-neutral-primary-hover);
  }

  &:not(:disabled):active,
  &.active:not(:disabled) {
    background: var(--cue-bg-neutral-primary-pressed);
  }

  &:disabled {
    color: var(--cue-content-neutral-disabled);
    background: var(--cue-bg-neutral-none);
    --uno: cursor-not-allowed;
  }
}
</style>
